import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { finalize, take } from 'rxjs/operators';
import { BRASIL_MASK } from 'src/app/core/constants/consts';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { Profile } from 'src/app/core/models/profile';
import { CheckTaskStatusService } from 'src/app/core/services/check-task-status-service/check-task-status-service';
import { ProfileService } from 'src/app/profile-home/service/profile.service';

@Component({
  selector: 'app-broker-modal-edition',
  templateUrl: './broker-modal-edition.component.html',
  styleUrls: ['./broker-modal-edition.component.scss']
})
export class BrokerModalEditionComponent implements AfterViewChecked, OnInit {

  @Input() showModal: boolean;
  @Input() profile: Profile;
  maxLength = 280;
  formEdition: FormGroup;
  phoneMask = BRASIL_MASK;
  disabledBiography: boolean;
  loadingEdition: boolean;
  isMobile: boolean;

  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef,
    private checkStatusService: CheckTaskStatusService,
    private environmentService: EnvironmentService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setMobileDevice(event.target.innerWidth);
  }

  ngOnInit(): void {
    this.setMobileDevice(window.innerWidth);
  }

  setMobileDevice(event) {
    if (event <= 1024) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  openEditModal() {
    this.checkOperationMarkets();
    this.buildForm();
    this.showModal = true;
    if (!this.isMobile) {
      document.body.style.paddingRight = '8px';
    }
    document.body.style.overflow = 'hidden';
  }

  closeModal(): void {
    this.showModal = false;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  onSubmit(): void {
    this.loadingEdition = true;
    const values = this.formEdition.value;
    if (!values.alternative_phone.phone) {
      delete values.alternative_phone;
    }
    this.profileService.profileEdit(values)
    .pipe(take(1))
    .subscribe(res => {
      this.checkTaskEditionId(res);
    });
  }

  checkTaskEditionId(res): void {
    this.checkStatusService.checkTaskStatus2(res.taskId, this.environmentService.getEnvVar('api_profile'))
      .pipe(take(1), finalize(() => this.showModal = this.loadingEdition = false))
      .subscribe(() => {
        this.profileService.setUpdateProfile();
      });
  }

  buildForm(): void {
    this.formEdition = this.fb.group({
      phone: this.fb.group({
        ddi: this.profile?.phone?.ddi || '+55',
        phone: [this.profile?.phone?.phone.replace(' ', '') || '', [
          Validators.required
        ]],
      }),
      alternative_phone: this.fb.group({
        ddi: this.profile?.alternative_phone?.ddi || '+55',
        phone: [this.profile?.alternative_phone?.phone.replace(' ', '') || ''],
      }),
      email: [{
        value: this.profile?.email || '',
        disabled: true
      }],
      biography: [{
        value: this.profile?.biography || this.profileService.getDefaultBiography(this.profile?.company),
        disabled: this.disabledBiography
      }, [
        Validators.required,
        Validators.maxLength(280)
      ]]
    }, { validator: this.checkIfBrokerPhoneAreEquals });
  }

  checkOperationMarkets(): void {
    if (this.profile?.operation_markets?.length) {
      const isPrimary = this.profile.operation_markets.includes('PRIMARY');
      this.disabledBiography = !isPrimary;
    }
  }

  checkIfBrokerPhoneAreEquals: ValidatorFn = (fg: FormGroup) => {
    const phone = fg.get('phone.phone').value;
    const alternativePhone = fg.get('alternative_phone.phone').value;
    return phone !== null && alternativePhone !== null && phone === alternativePhone
      ? { areEquals: true }
      : null;
  }
}
